const BASE_Z_INDEX = 10000;

export const Z_INDEX_MAP = {
    popover: BASE_Z_INDEX + 1500,
    toast: BASE_Z_INDEX + 1600,
    tooltip: BASE_Z_INDEX + 1700,
    educationTooltip: BASE_Z_INDEX + 1900,
} as const;
